import { action, flow, makeObservable, observable } from 'mobx';
import { NotifyApi } from '../apis';
import BaseStore from './BaseStore';

class NotifyStore extends BaseStore {

    notifies = [];

    notify = {};

    pagingNotifiesListScreen = {
        ...this.paging,
        page: 1,
        size: 10
    }

    constructor(rootStore) {
        super();
        makeObservable(this, {
            notifies: observable,
            notify: observable,
            pagingNotifiesListScreen: observable,
            getNotifies: flow.bound,
            getNotifyDetail: flow.bound,
            cleanNotifiesPaging: action.bound
        });
        this.rootStore = rootStore;
        this.api = new NotifyApi();
    }

    *getNotifies(searchParams) {
        try {
            
            const { size, page, sortDir, sortKey } = this.pagingNotifiesListScreen;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getNotify, payload);
            if(res?.ok) {
                this.notifies = res?.data?.elements || [];
                this.setAttrObservable('pagingNotifiesListScreen', res?.data?.paginate, true, false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getNotifyDetail(id, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getNotifyDetail, { id, payload });
            if(res?.ok) {
                this.notify = res?.data || {};
            }
        } catch (error) {
            console.log(error);
        }
    }

    cleanNotifiesPaging() {
        this.pagingNotifiesListScreen = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }
}

export default NotifyStore;
